import React, { useContext, useState } from 'react';

import { createAnexoDemanda } from '@app/api/demanda';
import {
  Button,
  CrudContext,
  FormatText,
  FormInput,
  FormSubmitButton,
  MasterDetailForm,
  Row,
  Widget,
} from '@digital/ui';
import { Modal } from 'antd';

import { UploadFile } from '@app/components';
import QuestionarioContext from '@app/hooks/useQuestionario';

interface Props {
  onUpdate: () => any;
}

function ModalIncluirAnexo(props: Props) {
  const { onUpdate } = props;
  const { demandaData } = useContext(QuestionarioContext);
  const [exibirModal, setExibirModal] = useState(false);
  const [arquivo, setArquivo] = useState<boolean>(true);

  const handleSubmit = (values: any) => {
    values.demandaId = demandaData.id;
    createAnexoDemanda(values).then(data => {
      if (data.valid) {
        setExibirModal(false);
        onUpdate();
      }
    });
  };

  return (
    <>
      <Row style={{ marginBottom: '16px' }}>
        <Button
          style={{ float: 'left' }}
          onClick={() => {
            setExibirModal(true);
          }}>
          INCLUIR ANEXO
        </Button>
      </Row>
      <Modal
        title="INCLUIR ANEXO"
        width="620px"
        visible={exibirModal}
        onCancel={() => {
          setExibirModal(false);
        }}
        footer={null}>
        <MasterDetailForm
          key="formAnexo"
          onSubmit={handleSubmit}
          actions={[
            <Button
              type="link"
              onClick={() => {
                setExibirModal(false);
              }}
              key="close">
              Fechar
            </Button>,
            <FormSubmitButton noIcon type="primary">
              <FormatText id="ui.commons.save" uppercase />
            </FormSubmitButton>,
          ]}>
          <Widget>
            <Row>
              <FormInput name="descricaoDocumento" label="Descrição do Documento" span={12} required />
              <UploadFile nameFormData={'arquivo'} label={'INSERIR ANEXO'} hasFile={arquivo} type="primary" />
            </Row>
          </Widget>
        </MasterDetailForm>
      </Modal>
    </>
  );
}

export default ModalIncluirAnexo;
